import { render, staticRenderFns } from "./edit-proof-of-payment-widget.vue?vue&type=template&id=19ef41e1&"
import script from "./edit-proof-of-payment-widget.vue?vue&type=script&lang=js&"
export * from "./edit-proof-of-payment-widget.vue?vue&type=script&lang=js&"
import style0 from "./edit-proof-of-payment-widget.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports